<script lang="ts" setup>

  type Props = {
    icon?: string
    label?: string
    subLabel?: string
    disabled?: boolean
  }
  const props = withDefaults(defineProps<Props>(), {
    icon: 'location',
    label: '',
  })
</script>
<template>
  <div
    class="c-location-item"
    :class="{disabled: disabled}"
  >
    <SvgIcon
      :icon="props.icon"
      :desktop-height="24"
      :desktop-width="24"
      :height="24"
      :width="24"
    />
    <span v-html="props.label" />
  </div>
</template>
<style scoped>

.c-location-item {
  display: flex;
  width: 100%;
  box-sizing: border-box;
  flex-direction: row;
  align-items: center;
  padding: 1em 1.5em;
  cursor: pointer;
  transition: background-color ease-in-out 0.15s;

  .c-icon {
    margin-right: 1.5em;
    color: var(--color-secondary);
    opacity: 0.5;
  }

  span {
    color: var(--color-secondary);
    font-family: Open-Sans, sans-serif;
    font-size: 1em;
    font-weight: normal;
    opacity: 0.8;
    transition: color 0.15s ease-out, opacity 0.15s ease-out;

    &:deep(em) {
      font-weight: bold;
    }

    &:deep(small) {
      font-size: .75rem;
      font-style: italic;
    }
  }

  &.disabled{
    cursor: not-allowed;
  }

  &:not(.disabled):hover {
    span {
      color: var(--color-primary);
      opacity: 1;
    }
  }
}
</style>
